<script>
  import Splash from '../assets/home/splash.svelte';
  import Video from '../assets/home/video.svelte';
  import WhatWeDo from '../assets/home/WhatWeDo.svelte';
  import WhoWeAre from '../assets/home/WhoWeAre.svelte';
  import Connect from '../assets/home/Connect.svelte';
  import Documentary from '../assets/home/Documentary.svelte';
  import ContactSection from '../assets/home/ContactSection.svelte';
  import Donate from '../assets/home/Donate.svelte';
  import { onMount, onDestroy } from 'svelte';

  // Reactive variable for window width
  let windowWidth;

  // Function to update window width
  function updateWidth() {
    windowWidth = window.innerWidth;
  }

  onMount(() => {
    // Update width on mount
    updateWidth();
    // Add event listener for window resize
    window.addEventListener('resize', updateWidth);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  });
</script>

<main>
  <Splash />
  <Video
  videoSRC="https://www.youtube.com/embed/HnMWgmA0HhI?si=WUfAO5iaB1WugBmq"
  />
  <WhatWeDo />
  {#if windowWidth > 768}
    <WhoWeAre />
  {/if}
  <Connect />
  <Documentary />
  <ContactSection />
  <Donate />
</main>